import { Component } from '@angular/core';
import { LogoComponent } from '../logo/logo.component';

@Component({
	selector: 'vis-maintenance',
	imports: [LogoComponent],
	templateUrl: './maintenance.component.html',
	styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent {}
